













import Vue from 'vue'

import { Component, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'
import AppSnack from '@/components/AppSnack.vue'
import AppLayout from '@/components/AppLayout/AppLayout.vue'
import { User } from '@/modules/User/interfaces/user'
import AppLoader from '@/components/AppLoader.vue'
import { dispatchSignIn } from '@/store/dispatches'
import { getMe } from '@/modules/User/gql/user.gql'
import { zoomCallNotification } from '@/modules/Zoom/gql/zoom.gql'
import { Notification } from 'element-ui'
import CallerDialog from '@/modules/PhoneLog/components/callerDialog.vue'
import { parsePhoneNumber } from '@/utils/phoneNumberFormat'

@Component({
  components: {
    AppSnack,
    AppLoader,
    CallerDialog,
    AppLayout
  }
})
export default class App extends Vue {
  name = 'App'

  noMenu = ['SignIn']

  windowSize = {
    w: 0,
    h: 0
  }

  ready = false

  isToken = false

  routeName = ''

  targetPhone = ''
  isCallerDialog = false

  @State(state => state.user.me) me!: User
  @State(state => state.app.isLoading) isLoading!: boolean
  @State(state => state.app.isFold) isFold!: boolean
  @State(state => state.app.appDrawerLayout) appDrawerLayout!: string

  mounted () {
    const token = localStorage.getItem(process.env.VUE_APP_JWT_NAME || 'VERGE_JWT_TOKEN')
    this.onResize()

    if (token) {
      this.getMe()
      this.isToken = true
    } else {
      this.isToken = false
      this.ready = true
    }

    this.routeName = this.$route.name || ''
  }

  @Watch('me')
  onMeChanged (val: User) {
    if (val) {
      this.ready = true
      this.isToken = true
      this.getZoomNotification()
    }
  }

  @Watch('$route')
  onRouteChanged (val: any) {
    this.routeName = val.name
  }

  translatePhoneStatus (type: string) {
    let typeText = ''
    switch (type) {
      case 'phone.callee_ringing':
        typeText = ' is ringing'
        break
      case 'phone.callee_answered':
        typeText = ' is connected'
        break
      case 'phone.callee_ended':
        typeText = ' is ended'
        break
      case 'phone.callee_missed':
        typeText = ' was missed'
        break
      case 'phone.callee_rejected':
        typeText = ' was rejected'
        break
      default:
        break
    }
    return typeText
  }

  hideCallerDialog () {
    this.isCallerDialog = false
  }

  showDialogHandler (phone: string) {
    this.targetPhone = phone
    this.isCallerDialog = true
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
  }

  async getMe () {
    try {
      const result = await this.$apollo.query({
        query: getMe
      })

      if (result.errors) {
        localStorage.removeItem(process.env.VUE_APP_JWT_NAME || 'VERGE_JWT_TOKEN')
        if (this.$route.name !== 'SignIn') {
          this.ready = true
          this.$router.replace({ name: 'SignIn' })
        }
      } else {
        dispatchSignIn(result.data.me)
      }
    } catch (e) {
      localStorage.removeItem(process.env.VUE_APP_JWT_NAME || 'VERGE_JWT_TOKEN')
    }
  }

  async getZoomNotification () {
    const that = this
    const observer = await this.$apollo.subscribe({
      query: zoomCallNotification,
      variables: {
        userId: Number(this.me.id)
      }
    })

    observer.subscribe({
      next (data) {
        const message = `🔔 ${parsePhoneNumber(data.data.zoomCallNotification.callerNumber)}${that.translatePhoneStatus(data.data.zoomCallNotification.event)}`
        if (data.data.zoomCallNotification.callerNumber.indexOf('+') !== -1) {
          Notification({
            title: '',
            message: message,
            position: 'bottom-left',
            duration: (data.data.zoomCallNotification.event === 'phone.callee_missed' || data.data.zoomCallNotification.event === 'phone.callee_ended') ? 5000 : 0,
            onClick: function () {
              that.showDialogHandler(data.data.zoomCallNotification.callerNumber)
            }
          })
        }
      }
    })
  }
}
